import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { HeaderBone, HeaderBoneProps } from '../../organisms/HeaderBone/HeaderBone';
import { ToolbarBone, ToolbarBoneProps } from '../../organisms';

interface HeaderSkeletonProps extends ToolbarBoneProps, HeaderBoneProps {
    /** Afficher la bar d'outils au-dessus de l'en-tête */
    withToolbar?: boolean;
    /** Styles global personnalisés */
    globalSx?: SxProps<Theme>;
    /** Styles toolbar personnalisés */
    toolbarSx?: SxProps<Theme>;
    /** Styles header personnalisés */
    headerSx?: SxProps<Theme>;
}

export const HeaderSkeleton: React.FunctionComponent<HeaderSkeletonProps> = function ({
    contentLeftWidth,
    contentRightWidth,
    contentWidth,
    headerHeight,
    withIcon = true,
    iconWidth,
    subItemCount,
    withToolbar = false,
    globalSx = {},
    toolbarSx = {},
    headerSx = {},
}) {
    const toolbarBoneProps: ToolbarBoneProps = {
        contentLeftWidth,
        contentRightWidth,
        sx: toolbarSx,
    };

    const headerBoneProps: HeaderBoneProps = {
        contentWidth,
        headerHeight,
        withIcon,
        iconWidth,
        subItemCount,
        sx: headerSx,
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: '300px',
                width: '100%',
                ...globalSx,
            }}
        >
            {withToolbar ? <ToolbarBone {...toolbarBoneProps} /> : null}
            <HeaderBone {...headerBoneProps} />
        </Box>
    );
};
